import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider, createUserWithEmailAndPassword, signInWithEmailAndPassword, updateProfile } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage";
import { doc, setDoc } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyB_Lnj4FYBL8tAHxGxxneFeEw4h4Q-_I-8",
  authDomain: "closingchecklist-272ff.firebaseapp.com",
  projectId: "closingchecklist-272ff",
  storageBucket: "closingchecklist-272ff.firebasestorage.app",
  messagingSenderId: "814152402711",
  appId: "1:814152402711:web:61b375b3f576a892ed5952",
  measurementId: "G-9L8RQN5JBN"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const googleAuthProvider = new GoogleAuthProvider();
const analytics = getAnalytics(app);

const storage = getStorage(app);

const signUpWithEmail = async (email: string, password: string, profileName: string) => {
  const userCredential = await createUserWithEmailAndPassword(auth, email, password);
  await updateProfile(userCredential.user, { displayName: profileName });
  await setDoc(doc(db, "users", userCredential.user.uid), {
    displayName: profileName,
    email: userCredential.user.email,
  });
  return userCredential;
};

const signInWithEmail = (email: string, password: string) => {
  return signInWithEmailAndPassword(auth, email, password);
};

export { auth, db, googleAuthProvider, app, analytics, storage, signUpWithEmail, signInWithEmail };
